import axiosClient from "axiosClient";
import axiosClientStilo from "axiosClient/indexStilo";
import { getQueryString } from "utilities/common";
import { HEMP,STILO } from "utilities/constants";
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export async function fetchMasterCatalogProductsAPI(filters, data) {

    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`api/v1/product/master/catalogue?${getQueryString(filters)}`, data);
}